export default {
  _o: "allowCrawlerActivity",
  Yo: "baseUrl",
  Xo: "noCookies",
  Zo: "devicePropertyAllowlist",
  Aa: "disablePushTokenMaintenance",
  Wh: "enableLogging",
  Vh: "enableSdkAuthentication",
  qa: "manageServiceWorkerExternally",
  Kh: "minimumIntervalBetweenTriggerActionsInSeconds",
  $h: "sessionTimeoutInSeconds",
  Yh: "appVersion",
  Xh: "appVersionNumber",
  Ma: "serviceWorkerLocation",
  ka: "safariWebsitePushId",
  Zn: "localization",
  er: "contentSecurityNonce",
  re: "allowUserSuppliedJavascript",
  Ko: "inAppMessageZIndex",
  Qo: "openInAppMessagesInNewTab",
  Lh: "requireExplicitInAppMessageDismissal",
  Zh: "doNotLoadFontAwesome",
  Qh: "deviceId",
  _a: "serviceWorkerScope",
  Ea: "sdkFlavor",
  tn: "openCardsInNewTab",
};
